import React from 'react';
import auth from './app-auth';
import { actions as companyActions } from './app-dux/company-dux';

import loadHome from 'bundle-loader?lazy&title=Home!./components/routes/home';
import loadAttributes from 'bundle-loader?lazy&title=Programs!./components/routes/attributes';
import loadClient from 'bundle-loader?lazy&title=Programs!./components/routes/client';
import loadCodes from 'bundle-loader?lazy&title=Programs!./components/routes/codes';
import loadForms from 'bundle-loader?lazy&title=Programs!./components/routes/forms';

const Bundle = Component => props => <Component { ...props } />;

export const routes = [
  {
    title: 'Home',
    pattern: '/',
    load: loadHome
  },
  {
    title: 'Form Detail',
    pattern: '/:companyId/forms',
    load: loadForms
  },
  {
    title: 'Clients Details',
    pattern: '/:companyId/clients',
    load: loadClient
  },
  {
    title: 'Codes',
    pattern: '/:companyId/codes',
    load: loadCodes
  },
  {
    title: 'Attributes',
    pattern: '/:companyId/:regId/forms/:formId',
    load: loadAttributes
  }
];

// export const getMiddleware = store => {
//   return [
//     // Company
//     (action, nextRoute, prevRoute) => {
//       if (nextRoute.state && nextRoute.state.params) {
//         store
//           .dispatch(companyActions.setCompany(nextRoute.state.params.companyId))
//           .then(() => {
//             action.ok();
//           });
//       } else {
//         action.ok();
//       }
//     },
//     // Load Bundles
//     (action, nextRoute, prevRoute) => {
//       if (
//         nextRoute.match &&
//         !nextRoute.match.render &&
//         typeof nextRoute.match.load === "function"
//       ) {
//         nextRoute.match.load(asyncModule => {
//           nextRoute.match.render = Bundle(
//             asyncModule.default ? asyncModule.default : asyncModule
//           );
//           action.ok();
//         });
//       } else {
//         action.ok();
//       }
//     }
//   ];
// };

export const getMiddleware = ( store ) => {
  return [
      // Company
      ( action, nextRoute, prevRoute ) => {
          // we aren't signed in yet, so continue
          if ( !auth.state.access_token ) {
              return action.ok();
          }

          const nextCompanyId = nextRoute?.state?.params?.companyId;
          // if the next companyId is the same as the last companyId, continue
          if ( nextCompanyId === auth.state.company_id ) {
              return action.ok();
          }

          // switch to the new company
          store.dispatch(
              companyActions.setCompany( nextRoute.state.params.companyId )
          ).then( () => {
              action.ok();
          } );
      },

      // Load Bundles
      ( action, nextRoute, prevRoute ) => {
          if ( nextRoute.match && !nextRoute.match.render &&
              typeof nextRoute.match.load === 'function' ) {

              nextRoute.match.load( ( asyncModule ) => {
                  nextRoute.match.render = Bundle( asyncModule.default ? asyncModule.default : asyncModule );
                  action.ok();
              } );
          } else {
              action.ok();
          }
      }
  ];
};
